import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './controllers/login.component';
import { RegisterComponent } from './controllers/register.component';
import { StaffRegisterComponent } from './controllers/staff-register.component';
import { JoinAgencyComponent } from './controllers/join-agency.component';
import { AdsComponent } from './controllers/ads.component';
import {PasswordResetComponent} from './controllers/password-reset.component';
import {OrderValidatedComponent} from './controllers/order-validated.component';
import {PasskeyVerifyComponent} from './controllers/passkey-verify.component';
import {PasskeyRecoveryComponent} from './controllers/passkey-recovery.component';
import {PasskeyEnrolComponent} from './controllers/passkey-enrol.component';
import {PasskeyResetComponent} from './controllers/passkey-reset.component';
import {PasskeyAddDeviceComponent} from './controllers/passkey-add-device.component';
import {PasskeyDeviceCodeComponent} from './controllers/passkey-device-code.component';
import {PasskeyUnlockComponent} from './controllers/passkey-unlock.component';
import {LoginGuard} from '../_guards';
import {RegistrationGuard} from '../_guards/registration.guard';
import {ReopenLockGuard} from '../_guards/reopen-lock.guard';

const routes: Routes = [
    { path: 'login', canActivate: [LoginGuard], component: LoginComponent },
    { path: 'register',canActivate: [RegistrationGuard], component: RegisterComponent},
    { path: 'ads', component: AdsComponent},
    { path: 'register/:id', component: RegisterComponent},
    { path: 'staff/register/:token', component: StaffRegisterComponent},
    { path: 'join-agency/:token', component: JoinAgencyComponent},
    { path: 'password-reset/:token', component: PasswordResetComponent},
    { path: 'orders/verify/:token', component: OrderValidatedComponent},
    { path: 'passkey-verify', component: PasskeyVerifyComponent },
    { path: 'passkey-recovery', component: PasskeyRecoveryComponent },
    { path: 'passkey-enrol', component: PasskeyEnrolComponent },
    { path: 'passkey-reset/:token', component: PasskeyResetComponent },
    // JS-1396: needs a signed-in session and enrols on it - lockable.
    { path: 'passkey-add-device', canActivate: [ReopenLockGuard], component: PasskeyAddDeviceComponent },
    { path: 'passkey-device-code', component: PasskeyDeviceCodeComponent },
    // JS-1396: leaving the unlock screen for an app screen is refused while locked.
    { path: 'passkey-unlock', canDeactivate: [ReopenLockGuard], component: PasskeyUnlockComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [RegistrationGuard]
})
export class AuthRoutingModule {
}
